import { render, staticRenderFns } from "./edit-admin-user.vue?vue&type=template&id=77a0fbf3"
import script from "./edit-admin-user.vue?vue&type=script&lang=ts"
export * from "./edit-admin-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports